// extracted by mini-css-extract-plugin
export default {"dashCol":"dashCol___Mn_7e","root":"root___pC3w6","selectCol":"selectCol___kiI53","label":"label___HNicF"};